module.exports = __webpack_public_path__ + "static/media/Kellanova_logo.svg 3.aa188d0b.png";